import $ from 'jquery';
window.$ = window.jQuery = $;
// Language
if ($(".header__language").length > 0) {
	$(".header__language").on("click", function () {
		$(this).parent().find(".header__hide").slideToggle(300);
	});
}

if ($(".header").length > 0) {
	$(window).on('resize', function () {
		var new_width = $(window).outerWidth();
		var min_width = 760;
		var container = $('.header');
		if (new_width <= min_width) {
			$('.header__menu').insertBefore($('.header__mobile-fixed'));
			$('.header__languages').insertAfter($('.header__mobile-fixed'));
		}
		if (new_width > min_width) {
			$('.header__menu').insertBefore($('.header__box'));
			$('.header__languages').insertAfter($('.header__burger'));
		}
	}).trigger('resize');
}

// Main menu open
if ($('.header__burger').length > 0) {
    $('.header__burger').on("click", function (event) {
		$(this).toggleClass('active');
		$('.header').toggleClass('active');
		$('body').toggleClass('lock');
		$('.header__mobile').toggleClass('active');
    });
}